/*
 * Copyright (c) 2018. Viscomp LLC. All rights are reserved!
 */

/**
 * Represents a paging gallery.
 */

import { Pagination } from "../Pagination";
import { parents } from "../../Utils";

/**
 * DOM helpers
 *
 * @type {{forEachEl: DOM.forEachEl}}
 */
const DOM = {
  forEachEl: function (elements, cb) {
    for (let i = 0; i < elements.length; i++) {
      cb && cb(elements[i], i);
    }
  }
};

/**
 * Paging gallery
 *
 * @param {Element} el
 * @param {Object} settings
 * @constructor
 */
const PagingGallery = function (el, settings) {
  this.galleryEl = el;
  this.totalImageCount = settings.totalImages;
  this.imagesPerPage = settings.imagesPerPage;
  this.ajaxLoading = settings.ajaxLoading;
  this.currentPage = 1;
  this.buildPaginator();
  this.renderCurrentPage();
};
PagingGallery.prototype.onChangePage = function (selectedPage) {
  this.currentPage = selectedPage;
  this.renderCurrentPage();
};
PagingGallery.prototype._forEachEl = function (elements, cb) {
  for (let i = 0; i < elements.length; i++) {
    cb && cb(elements[i], i);
  }
};
PagingGallery.prototype.renderCurrentPage = function () {
  let allImages = this.galleryEl.querySelectorAll("[data-image-el]");

  // remove all images
  DOM.forEachEl(allImages, function (el) {
    el.removeAttribute("src");
  });

  // render current page only
  let start = this.currentPage * this.imagesPerPage - this.imagesPerPage;
  let end = this.currentPage * this.imagesPerPage;
  DOM.forEachEl(allImages, function (el, index) {
    if (index >= start && index < end) {
      let href = el.getAttribute("data-cms-src");
      el.setAttribute("src", href);
      let parents = parents(el, "div.cms-gallery-image");
      parents.forEach(_el => {
        _el.classList.remove("hidden");
      });
    } else {
      let parents = parents(el, "div.cms-gallery-image");
      parents.forEach(_el => {
        _el.classList.add("hidden");
      });
    }
  });
};
PagingGallery.prototype.buildPaginator = function () {
  let div = document.createElement("div");
  div.classList.add("col");
  let ul = document.createElement("ul");
  ul.classList.add("gallery-pager");
  new Pagination(ul, {
    wrapperClass: "gallery-nav",
    size: Math.ceil(this.totalImageCount / this.imagesPerPage),
    // pages size
    page: 1,
    // selected page
    step: 3,
    // pages before and after current
    onChange: function (currentPage) {
      this.onChangePage(currentPage);
    }.bind(this)
  });
  div.appendChild(ul);
  this.galleryEl.appendChild(div);
};
export default PagingGallery;